import router from "@/router";
import { buildStyle } from "@appbase/util/popup-helper"

const queryToString = (query: common.QueryOption): string => {
    var returnString = ''
    
    if(query) {
        var keys = Object.keys(query);
        
        for(var i=0; i< keys.length; i++) {
            var key = keys[i];
            returnString += `${key}=${query[key]}${i == keys.length - 1 ? '' : '&'}`
        }
    }      
    
    return returnString;
}

export const enum OpenType { 
    ModalRead, 
    PopupRead, 
    ModalWrite, 
    PopupWrite,
    ModalEdit,
    PopupEdit,
    ModalReply,
    PopupReply
};

export const open = function(type: OpenType, option: common.OpenOption) {               
    const style = buildStyle({
        width: option.width || 1024,
        height: option.height || 850
    });

    if(type == OpenType.PopupRead) {                
        window.open(
            `${option.baseUrl}readPopup?SYSID=${option.boardId}&ARTICLEID=${option.articleId}${option.query ? `&${queryToString(option.query)}` : ''}`,
            `BoardRead-${option.articleId}`,
            style);
    }

    if(type == OpenType.ModalRead) {
        router.push({
            path: 'modal/read',
            append: true,

            query: option.query ? {                  
                SYSID: option.boardId?.toString(),
                ARTICLEID: option.articleId?.toString(),
                ...option.query              
            } : {
                SYSID: option.boardId?.toString(),
                ARTICLEID: option.articleId?.toString()
            }
        })
    }

    if(type == OpenType.PopupWrite) {
        window.open(
            `${option.baseUrl}writePopup?SYSID=${option.boardId}${option.query ? `&${queryToString(option.query)}` : ''}`,
            "BoardWrite",
            style);       
    }

    if(type == OpenType.ModalWrite) {
        router.push({
            path: 'modal/write',
            append: true,
            query: option.query ? {                  
                SYSID: option.boardId?.toString(),
                ...option.query               
            } : {
                SYSID: option.boardId?.toString()
            }
        })
    }

    if(type == OpenType.PopupEdit) {
        var path = router.currentRoute.path.replace('readPopup', 'writePopup');

        router.push({
            path: path,
            query: option.query ? {
                ...router.currentRoute.query,
                ...option.query
            } : router.currentRoute.query
        });
    }

    if(type == OpenType.ModalEdit) {
        var path = router.currentRoute.path.replace('read', 'write');

        router.push({
            path: path,
            query: option.query ? {
                ...router.currentRoute.query,
                ...option.query
            } : router.currentRoute.query
        })
    }

    if(type == OpenType.PopupReply) {
        var path = router.currentRoute.path.replace('readPopup', 'writePopup');

        router.push({
            path: path,
            query: option.query ? {
                SYSID: option.boardId?.toString(),
                PARENTARTICLE: option.parentArticle?.toString(),
                ...option.query
            } : {
                SYSID: option.boardId?.toString(),
                PARENTARTICLE: option.parentArticle?.toString()
            }
        });
    }

    if(type == OpenType.ModalReply) {
        var path = router.currentRoute.path.replace('read', 'write');

        router.push({
            path: path,
            query: option.query ? {
                SYSID: option.boardId?.toString(),
                PARENTARTICLE: option.parentArticle?.toString(),
                ...option.query
            } : {
                SYSID: option.boardId?.toString(),
                PARENTARTICLE: option.parentArticle?.toString()
            }
        })
    }
}

